export default function (app) {
  app.controller('klPaymentMethodCtrl', [
    '$stateParams',
    '$window',
    'klPaymentService',
    'klConfigService',
    'klNotificationService',
    function ($stateParams, $window, PaymentService, ConfigService, NotificationService) {
      const ctrl = this;
      let originalPaymentMethod;
      ConfigService.getConfig().then((config) => {
        ctrl._config = config;
      });
      ctrl.currentCurrency = function () {
        return PaymentService.getCurrency();
      };
      ctrl.showHPM = () => {
        return ['sepa', 'cc', 'ach'].includes(ctrl.currentPaymentMethod) && ctrl.isEditingPayment;
      };
      ctrl.isLoading = true;
      if (!$stateParams.token) {
        PaymentService.fetchPaymentMethod().finally(() => {
          ctrl.isLoading = false;
          if (
            PaymentService.getPaymentMethodType() === 'invoice' ||
            !PaymentService.getPaymentMethodType()
          ) {
            ctrl.editPaymentMethod();
          } else if (PaymentService.getPaymentMethodType()) {
            ctrl.setPaymentMethodType(PaymentService.getPaymentMethodType());
          }
        });
      } else {
        PaymentService.updatePaymentMethod({ paypal: { token: $stateParams.token } })
          .then(() => {
            PaymentService.setPaymentMethod({ Type: 'PayPal' });
            ctrl.isEditingPayment = false;
          })
          .finally(() => {
            ctrl.isProcessing = false;
            ctrl.isLoading = false;
          });
      }

      function setPaymentMethodType(paymentMethodType) {
        if (ctrl.isProcessing || !paymentMethodType) {
          return;
        }
        ctrl.isLoadingPage = true;
        ctrl.currentPaymentMethod = paymentMethodType;

        PaymentService.initPaymentMethod(paymentMethodType)
          .catch((err) => {})
          .finally(() => (ctrl.isLoadingPage = false));
      }

      ctrl.getPaymentMethod = PaymentService.getPaymentMethod;
      ctrl.getPaymentMethodType = PaymentService.getPaymentMethodType;
      ctrl.setPaymentMethodType = setPaymentMethodType;
      ctrl.editPaymentMethod = function () {
        originalPaymentMethod = PaymentService.getPaymentMethodType();
        ctrl.isEditingPayment = true;
        if (originalPaymentMethod) {
          setPaymentMethodType(originalPaymentMethod);
        }
      };

      ctrl.cancelEditPaymentMethod = function () {
        setPaymentMethodType(originalPaymentMethod);
        ctrl.isEditingPayment = false;
      };

      ctrl.isReseller = PaymentService.isReseller();

      ctrl.save = function () {
        if (ctrl.isProcessing) {
          return;
        }
        ctrl.isProcessing = true;
        if (ctrl.currentPaymentMethod == 'cc' && ctrl.isEditingPayment) {
          $window.document.getElementById('z_hppm_iframe').style.minHeight = '500px';
        }
        PaymentService.submitPaymentMethod('customer-center')
          .then((paymentMethod) => {
            if (paymentMethod.paypal) {
              return ($window.location.href =
                ctrl._config.payPalCheckOutUrl + paymentMethod.paypal.token);
            }
            return PaymentService.updatePaymentMethod(paymentMethod).then(() => {
              NotificationService.putSuccess('success_payment_method_edit');
              ctrl.isEditingPayment = false;
            });
          })
          .catch((err) => {
            NotificationService.putError('payment', err);
          })
          .finally(() => (ctrl.isProcessing = false));
      };

      ctrl.disabledSave = () =>
        !ctrl.currentPaymentMethod || ctrl.isLoadingPage || ctrl.isProcessing;

      ctrl.showLoadingOverlay = () => ctrl.isLoadingPage;

      ctrl.disabledCancel = () => !PaymentService.getPaymentMethodId() || ctrl.isProcessing;
    },
  ]);
}
